import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { HomeComponent } from './home/home.component';

@NgModule({
    imports: [CommonModule, DashboardRoutingModule, SharedModule, HomeComponent],
})
export class DashboardModule {}
